import React, {ReactElement, useState} from 'react';
import {
  Typography,
  Button,
  LinkIcon,
  CheckIcon
} from '@customink/pigment-react';
import './index.scss';

type CopyLinkTextButton = {
  copyLink: string;
  variant?: 'primary' | 'secondary' | 'link';
  size?: 'small' | 'medium' | 'large';
  resetTime?: number;
  fullWidth?: boolean;
};

const CopyLinkTextButton: React.FC<CopyLinkTextButton> = ({
  copyLink,
  variant,
  size,
  resetTime,
  fullWidth
}: CopyLinkTextButton): ReactElement => {
  const [copyIcon, setCopyIcon] = useState(<LinkIcon />);
  const [copyText, setCopyText] = useState('Copy Link');

  const handleCopy = () => {
    setCopyIcon(<CheckIcon />);
    setCopyText('Link Copied');
    navigator.clipboard.writeText(copyLink);
    setTimeout(() => {
      setCopyIcon(<LinkIcon />);
      setCopyText('Copy Link');
    }, resetTime);
  };

  return (
    <div className="copyLinkContainer">
      <Button
        className={`copy-button ${variant}`}
        variant={variant}
        onClick={handleCopy}
        size={size}
        fullWidth={fullWidth}
        startIcon={copyIcon}>
        <Typography variant="captionLarge" className="link-text">
          {copyText}
        </Typography>
      </Button>
    </div>
  );
};

CopyLinkTextButton.defaultProps = {
  variant: 'secondary',
  size: 'small',
  resetTime: 3000,
  fullWidth: false
};

export default CopyLinkTextButton;
